<template>
    <div>实时监控</div>
</template>

<script>
export default {
  name: 'systemOperation'
}
</script>

<style scoped>

</style>
